import UserTaskListPage from './UserTaskListPage';

export default UserTaskListPage;
